var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { buildTextCanvas } from "./utilities";
import { ProgressTimeline } from "../src/timeline/progressTimeline";
import { TickerTimeline } from "../src/timeline/tickerTimeline";
import { TextOpacityDeformer } from "../src/deformers/text/TextOpacityDeformer";
import { ProgressIncrementer } from "../src/incrementer/progressIncrementer";
import { InterpolationCache } from "../src/interpolationCache";
import { FontAtlasTextGraphic, GRAPHIC_TYPE } from "../src/fontAtlasTextGraphic";
import { TextGraphicOpacityDeformer } from "../src/deformers/text_graphic/TextGraphicOpacityDeformer";
import { OneByOneIncrementer } from "../src/incrementer/oneByOneIncrementer";
import { TEXT_TRANSFORM_ENUM } from "../src/deformers/enums";
export var focusOnWordByWordByUsingGraphic = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, app, asset, graphicColor, graphicOpacityDeformer, wordCount, oneByOneOpacity, tickerTimeline, progressTimeline;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, buildTextCanvas("Lorem ipsum dolor sit amet, novum dolore concludaturque vis ne. Cu usu nibh idque, id sit mutat.")];
            case 1:
                _a = _b.sent(), app = _a.app, asset = _a.asset;
                graphicColor = new FontAtlasTextGraphic(asset);
                graphicColor.graphicType = GRAPHIC_TYPE.WORD;
                app.stage.addChildAt(graphicColor, 0);
                graphicColor._build();
                graphicOpacityDeformer = new TextGraphicOpacityDeformer();
                graphicColor.deform.addDeformer(graphicOpacityDeformer);
                wordCount = graphicColor.graphicCount;
                oneByOneOpacity = new OneByOneIncrementer(wordCount);
                oneByOneOpacity.update();
                graphicOpacityDeformer.opacities = oneByOneOpacity.array;
                tickerTimeline = new TickerTimeline(app.ticker);
                tickerTimeline.duration = 8000; // 1 second
                tickerTimeline.play();
                progressTimeline = new ProgressTimeline();
                progressTimeline.start = 0;
                progressTimeline.end = 6000;
                app.ticker.add(function () {
                    var progress = progressTimeline.value(tickerTimeline.time);
                    oneByOneOpacity.progress = progress;
                    oneByOneOpacity.update();
                    graphicOpacityDeformer.opacities = oneByOneOpacity.array;
                });
                app.ticker.start();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Focus on each word one at a time by toggling the word's opacity from partially transparent to fully opaque.
 */
export var focusOnWordByWordByUsingOpacity = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, app, asset, steppedInterpolationCache, assetOpacityDeformer, assetGlyphCount, opacityIncrementer, tickerTimeline, progressTimeline;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, buildTextCanvas("Lorem ipsum dolor sit amet, novum dolore concludaturque vis ne. Cu usu nibh idque, id sit mutat.")];
            case 1:
                _a = _b.sent(), app = _a.app, asset = _a.asset;
                steppedInterpolationCache = new InterpolationCache(100, 'stepped', 0.25, 1.0);
                assetOpacityDeformer = new TextOpacityDeformer();
                asset.deform.addDeformer(assetOpacityDeformer);
                assetOpacityDeformer.transformType = TEXT_TRANSFORM_ENUM.WORD;
                assetGlyphCount = assetOpacityDeformer._expectTransformsLength(1);
                opacityIncrementer = new ProgressIncrementer(assetGlyphCount, steppedInterpolationCache, 1);
                opacityIncrementer.duration = 5;
                opacityIncrementer.update();
                assetOpacityDeformer.opacities = opacityIncrementer.array;
                tickerTimeline = new TickerTimeline(app.ticker);
                tickerTimeline.duration = 8000; // 1 second
                tickerTimeline.play();
                progressTimeline = new ProgressTimeline();
                progressTimeline.start = 0;
                progressTimeline.end = 6000;
                app.ticker.add(function () {
                    var progress = progressTimeline.value(tickerTimeline.time);
                    opacityIncrementer.progress = progress;
                    opacityIncrementer.update();
                    assetOpacityDeformer.opacities = opacityIncrementer.array;
                });
                app.ticker.start();
                return [2 /*return*/];
        }
    });
}); };
